// SignIn.js
import { useState } from "react";
import { SignInForm } from "../components/SignInForm/SignInForm";
import { SignUpForm } from "../components/SignUpForm/SignUpForm";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { BrandSection } from "../components/SignInPageBrandSection/BrandSection";

export const SignIn = () => {
  const [showSignUpComponent, setShowLoginComponent] = useState(false);
  const navigate = useNavigate();
  const { signUp, signIn } = useAuth();

  function toggleBetweenSignUpAndSignIn() {
    setShowLoginComponent(!showSignUpComponent);
  }

  const handleSignInResponse = (signInAttempt) => {
    if (signInAttempt?.code === 403) {
      navigate("/Verification");
    } else {
      navigate("/");
    }
  };

  const handleSignUpResponse = async (e, email) => {
    e.preventDefault();
    localStorage.setItem("pendingVerificationEmail", email);
    // Navigate to verification page
    navigate("/verification", { state: { email: email } });
  };

  return (
    <div className="min-h-screen w-full flex flex-col md:flex-row bg-gray-50">
      {/* Brand Section */}
      <BrandSection />

      {/* Form Section */}
      <div className="w-full md:flex-[4] flex-1 flex flex-col items-center justify-center bg-white shadow-2xl md:shadow-none md:rounded-none -mt-8 md:mt-0 z-10 p-6 md:p-8 min-h-[60vh] md:min-h-screen">
        {showSignUpComponent ? (
          <SignUpForm
            signUp={signUp}
            toggleBetweenSignUpAndSignIn={toggleBetweenSignUpAndSignIn}
            handleSubmit={handleSignUpResponse}
          />
        ) : (
          <SignInForm
            signIn={signIn}
            toggleBetweenSignUpAndSignIn={toggleBetweenSignUpAndSignIn}
            handleSignInResponse={handleSignInResponse}
          />
        )}
      </div>
    </div>
  );
};
